var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVariance(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_32_985)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.8078 9.8172C14.0641 10.0735 14.0641 10.489 13.8078 10.7453L11.6203 12.9323C11.2099 13.3428 10.5 13.0551 10.5 12.4683V11.375H8.8926C8.8476 11.375 8.80309 11.3657 8.76182 11.3478C8.72055 11.3299 8.68341 11.3037 8.65271 11.2708L6.72345 9.20369L8.18177 7.64118L9.625 9.1875H10.5V8.09427C10.5 7.50807 11.2094 7.21932 11.6203 7.63022L13.8078 9.8172ZM0.328125 4.8125H2.625L4.06823 6.35882L5.52655 4.79631L3.59729 2.72923C3.56659 2.69634 3.52945 2.67011 3.48818 2.65218C3.44691 2.63425 3.4024 2.625 3.3574 2.625H0.328125C0.146918 2.625 0 2.77192 0 2.95312V4.48437C0 4.66558 0.146918 4.8125 0.328125 4.8125ZM10.5 4.8125V5.90581C10.5 6.49261 11.2099 6.78026 11.6203 6.36986L13.8078 4.1828C14.0641 3.92651 14.0641 3.51099 13.8078 3.25472L11.6203 1.06774C11.2094 0.656823 10.5 0.9456 10.5 1.53177V2.625H8.8926C8.8476 2.625 8.80309 2.63425 8.76182 2.65218C8.72055 2.67011 8.68341 2.69634 8.65271 2.72923L2.625 9.1875H0.328125C0.146918 9.1875 0 9.33442 0 9.51562V11.0469C0 11.2281 0.146918 11.375 0.328125 11.375H3.3574C3.44835 11.375 3.53522 11.3372 3.59729 11.2708L9.625 4.8125H10.5Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_32_985"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "currentColor"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVariance);
export default __webpack_public_path__ + "static/media/variance.b46068cf46443ce5a3c87484f3f93888.svg";
export { ForwardRef as ReactComponent };